import React from 'react';

const UserFeedbackFormModal = React.lazy(() => import('../components/FormModal'));
const userFeedbackModalRegistry = {
    crm_userFeedbackId: UserFeedbackFormModal
};
export default userFeedbackModalRegistry;
